import { surfaces } from '@ui/kit/design-tokens';
import { makeScalarToken, makeSelectors } from '@utils/css';

const hotspotSurface = surfaces.accent.default.__extend("--hotspot-color");
const imageScale = makeScalarToken("--hotspot-scale", "1");
const aspectRatio = "_mwa1fajvqv";
const imageWrapper = "_mwi1aapci1";
const imageContainer = "_mwitvywxe";
const image = "_mwid8qa1i";
const hotspotList = "_mwh1c0p3sf";
const hotspotModifiers = makeSelectors({
  withoutPulse: "_mww1ax8bq3",
  withIndex: "_mwwb29a7s",
  withGraphic: "_mww1e90t35",
  active: "_mwat7qtpz"
});
const hotspot = "_mwh9huzx2";
const trigger = "_mwt11785xz";
const hotspotGraphic = "_mwha3ixdk";
const hotspotBullet = "_mwhlcuz42";
const overlay = "_mwocp9abf";

export { aspectRatio, hotspot, hotspotBullet, hotspotGraphic, hotspotList, hotspotModifiers, hotspotSurface, image, imageContainer, imageScale, imageWrapper, overlay, trigger };
import "./_content.style.linaria.module.css";
//# sourceMappingURL=_content.style.js.map
